import React from 'react'
import { IKavTitleItem } from '../../../../../../modules/API/Distribution/models/kavTitle'
import TitleLayout from '../../../kosherTeudot/generic/TitleLayout'
import TitleRowItem from '../../../kosherTeudot/generic/TitleRowItem'
import LocationIcon from '../../../../../../generic/icons/IconLib/MapPinIcon'
import PalletIcon from '../../../../../../generic/icons/IconLib/PalletIcon'
import ScalesIcon from '../../../../../../generic/icons/IconLib/ScaleIcon'
import SpeedIcon from '../../../../../../generic/icons/IconLib/TruckIcon'
import UserIcon from '../../../../../../generic/icons/IconLib/UserIcon'
import styled from 'styled-components'
import TitleRow from '../../../kosherTeudot/generic/TitleRow'

interface Props extends IKavTitleItem {
    selectKav: (id: number) => void
}

const KavItem = ({
    selectKav, AreaDesc, AreaID, Customers, DriverName, GrossWeight, Total_Pallets, Loaded
}: Props) => {
    const handleSelectKav = () => {
        selectKav(AreaID)
    }
  return (
    <TitleLayout borderColor={Loaded ? 'rgb(128, 224, 129)' : 'tomato'} onClick={handleSelectKav}>
        <TitleRow>
            <TitleRowItem name={AreaDesc.trim()} icon={<SpeedIcon />} />
        </TitleRow>
        <TitleRow>
            <TitleRowItem name={DriverName.trim()} icon={<UserIcon />} />
            <TitleRowItem name={Customers} icon={<LocationIcon />} />
        </TitleRow>
        <TitleRow>
            <TitleRowItem name={Total_Pallets} icon={<PalletIcon />} />
            <TitleRowItem name={GrossWeight.toFixed(1)} icon={<ScalesIcon />} />
        </TitleRow>
    </TitleLayout>
  )
}

export default KavItem